import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);


import fingerIcon from '../assets/icons/finger.vue';
import rowLeft from '../assets/icons/rowLeft.vue';
import rowRight from '../assets/icons/rowRight.vue';
import pencil from '../assets/icons/pencil.vue';
import discount from '../assets/icons/discount.vue';
import calendar from '../assets/icons/calendar.vue';

export default new Vuetify({
	theme: {
		themes: {
			light: {
				YellowColor: '#fbaf3f',
				blue: '#559bbd',
				grey: '#959595',
				black: '#303030',
				colorInput: '#dbdee2',
			},
		},
	},
	icons: {
		values: {
			finger: {
				component: fingerIcon,
			},
			rowLeft: {
				component: rowLeft,
			},
			rowRight: {
				component: rowRight,
			},
			pencil: {
				component: pencil,
			},
			discount: {
				component: discount,
			},
			calendar: {
				component: calendar,
			},
		},
	},
});
